import { render, staticRenderFns } from "./C-4-1-2__ProductDownload-Edit.vue?vue&type=template&id=648c5b21&"
import script from "./C-4-1-2__ProductDownload-Edit.vue?vue&type=script&lang=js&"
export * from "./C-4-1-2__ProductDownload-Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
